import { getApiKey, getAccessToken } from '../utils/storage';
import { getApiUrl } from '../utils/api';

const getAuthHeaders = (): Record<string, string> => {
  const accessToken = getAccessToken();
  const apiKey = getApiKey();

  return {
    'Content-Type': 'application/json',
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(apiKey && { 'X-API-Key': apiKey }),
  };
};

export interface DeleteInstructionSetResponse {
  success: boolean;
  message: string;
}
export const deleteInstructionSet = async (connectionId: string, version: number): Promise<DeleteInstructionSetResponse> => {
  try {
    const response = await fetch(getApiUrl(`/v1/instruction-sets/${connectionId}/version/${version}`), {
      method: 'DELETE',
      headers: getAuthHeaders(),
      // Note: DELETE body is usually ignored or optional, but here we don't send one.
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: DeleteInstructionSetResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error deleting instruction set:', error);
    throw error;
  }
};
export interface InstructionSet {
  id: string;
  connection_id: string;
  version: number;
  instructions: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface InstructionSetsResponse {
  items: InstructionSet[];
  total_count: number;
  connection_id: string;
}

export interface RollbackResponse {
  success: boolean;
  message: string;
  version?: number;
}

export const fetchInstructionSets = async (connectionId: string): Promise<InstructionSetsResponse> => {
  try {
    const response = await fetch(getApiUrl(`/v1/instruction-sets/${connectionId}/history`), {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: InstructionSetsResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching instruction sets:', error);
    throw error;
  }
};

export const rollbackToVersion = async (connectionId: string, version: number): Promise<RollbackResponse> => {
  try {
    const response = await fetch(getApiUrl(`/v1/instruction-sets/${connectionId}/rollback`), {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ version }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: RollbackResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error rolling back to version:', error);
    throw error;
  }
};
